import { render, staticRenderFns } from "./TemplateTextArea.vue?vue&type=template&id=97116af6"
import script from "./TemplateTextArea.vue?vue&type=script&lang=js"
export * from "./TemplateTextArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports